export default "__VITE_ASSET__CBmndOUv__"